import { CodeBracketSquareIcon } from '@heroicons/react/24/outline';
import { ToolTipWrap } from './ToolTipWrap';

/**
 * SiesaLogIcon - Componente reutilizable para mostrar el estado de logs de Siesa
 *
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.row - Objeto con los datos de la fila
 * @param {string|number} props.itemID - ID único del elemento (ej: row.SOLICITUD_ID, row.SOLICITUD_ANTICIPO_ID)
 * @param {string} props.consecutivoField - Campo que contiene el consecutivo (ej: 'SOLICITUD_ANTICIPO_CONSECUTIVO', 'SOLICITUD_CONSECUTIVO')
 * @param {string} props.responseField - Campo que contiene la respuesta JSON (ej: 'SOLICITUD_EXT_RESPUESTA', 'SIESA_ESTADO')
 * @param {string} [props.responseCodeField] - Campo directo del código de respuesta (opcional, si no viene en JSON)
 * @param {Function} props.onIconClick - Función que se ejecuta al hacer click en el ícono
 * @param {string} [props.tooltipPrefix='tooltipSiesaLog'] - Prefijo para el tooltip
 * @param {string} [props.customMessage] - Mensaje personalizado para el tooltip
 */
export const SiesaLogIcon = ({
  row,
  itemID,
  consecutivoField,
  responseField,
  responseCodeField,
  onIconClick,
  tooltipPrefix = 'tooltipSiesaLog',
  customMessage,
}) => {
  // Validación: Si no hay consecutivo, no mostrar el ícono
  if (!row[consecutivoField]) {
    return null;
  }

  // Obtener el código de respuesta
  let responseCode;

  if (responseCodeField && row[responseCodeField] !== undefined) {
    // Si se proporciona un campo directo para el código
    responseCode = row[responseCodeField];
  } else if (row[responseField]) {
    // Si viene en formato JSON, parsearlo
    try {
      const parsedResponse = JSON.parse(row[responseField]);
      responseCode = parsedResponse.codigo;
    } catch (error) {
      console.error('Error parsing response JSON:', error);
      responseCode = null;
    }
  } else {
    responseCode = null;
  }

  // Determinar el color basado en el código de respuesta
  const color = responseCode === 0 ? 'text-green-500' : 'text-red-500';

  // Determinar el mensaje del tooltip
  let tooltipMessage;
  if (customMessage) {
    tooltipMessage = customMessage;
  } else if (row[responseField]) {
    try {
      const parsedResponse = JSON.parse(row[responseField]);
      tooltipMessage = parsedResponse.mensaje || `Código: ${responseCode}`;
    } catch (error) {
      tooltipMessage = `Código: ${responseCode}`;
    }
  } else {
    tooltipMessage = `Código: ${responseCode}`;
  }

  const handleIconClick = () => {
    if (onIconClick) {
      const isSendFail = responseCode !== 0;
      onIconClick(row, isSendFail);
    }
  };

  return (
    <ToolTipWrap
      itemID={itemID}
      componentPrefix={tooltipPrefix}
      message={tooltipMessage}>
      <CodeBracketSquareIcon
        onClick={handleIconClick}
        className={`hover:fill-blue-500 h-5 w-5 transform cursor-pointer ${color} transition duration-300 hover:scale-110`}
      />
    </ToolTipWrap>
  );
};
